module.exports = __webpack_public_path__ + "static/media/VI.9089b8e3.svg";